import $ from "jquery";

/**
 * initializes the SVG loading
 *
 */

export function loadSVGs(wrapper) {
  const svgs = $(wrapper + " .xx-image__svg");

  if(typeof svgs !== 'undefined' && svgs.length > 0){
    svgs.each((index, svg) => {
      let src = svg.dataset.src;
      $(svg).load(src);
    });
  }
}

export function initSVGLoading() {
  console.log("Initialize Lazy Loading: Start");
  document.addEventListener("DOMContentLoaded", function() {
    let lazySvgs = [].slice.call(document.querySelectorAll(".xx-image__svg"));

    if(lazySvgs.length) {
      console.log(`Initialize Lazy Loading for ${lazySvgs.length} SVGs`);
      // check if IntersectionObserver is available
      if ("IntersectionObserver" in window) {
        let lazySvgObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              let svg = entry.target;
              let $svg = $(svg);
              let src = $svg.data("src");

              $svg.load(src, () => {
                if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                  let evt = document.createEvent('UIEvents');
                  evt.initUIEvent('resize', true, false, window, 0);
                  window.dispatchEvent(evt);
                } else {
                  $(window).trigger('resize');
                }
              });
              lazySvgObserver.unobserve(svg);
            }
          });
        });

        lazySvgs.forEach(function(lazySvg) {
          lazySvgObserver.observe(lazySvg);
        });
      } else {
        // Possibly fall back to a more compatible method here

        let active = false;

        const lazyLoad = function() {
          if (active === false) {
            active = true;

            setTimeout(function() {
              lazySvgs.forEach(function (lazySvg) {
                if ((lazySvg.getBoundingClientRect().top <= window.innerHeight && lazySvg.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazySvg).display !== "none") {
                  let svg = lazySvg;
                  let $svg = $(svg);
                  let src = $svg.data("src");
                  $svg.load(src, () => {
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                      let evt = document.createEvent('UIEvents');
                      evt.initUIEvent('resize', true, false, window, 0);
                      window.dispatchEvent(evt);
                    } else {
                      $(window).trigger('resize');
                    }
                  });

                  lazySvgs = lazySvgs.filter(function(svg) {
                    return svg !== lazySvg;
                  });

                  if (lazySvgs.length === 0) {
                    document.removeEventListener("scroll", lazyLoad);
                    window.removeEventListener("resize", lazyLoad);
                    window.removeEventListener("orientationchange", lazyLoad);
                  }
                }
              });

              active = false;
            }, 200);
          }
        };

        lazyLoad();

        document.addEventListener("scroll", lazyLoad);
        window.addEventListener("resize", lazyLoad);
        window.addEventListener("orientationchange", lazyLoad);
      }
    }
  });
}
